module.exports = __webpack_public_path__ + "static/img/theme_05.bdd55982.png";